// extracted by mini-css-extract-plugin
module.exports = {"view":"_3rZ-K9UIYlFACxZZmizqRc"};